import React from "react";
import BreadCrumbs from "../../common/breadcrumbs";

const DeliveryOrders = () => {
	return (
		<>
			<BreadCrumbs
				title="Order Management"
				data={[{ label: "Delivery Orders" }]}
			/>
			<div className="content-wrapper">
				<div className="card">
					<div className="card-body text-center py-5">
						<div className="coming-soon-container">
							<div className="mb-4">
								<i
									className="bx bx-package"
									style={{ fontSize: "4rem", color: "#6c757d" }}
								></i>
							</div>
							<h3 className="mb-3">Delivery Orders - Coming Soon!</h3>
							<p className="text-muted mb-4">
								Our development team is working hard to bring you delivery order
								management. This exciting feature will be available soon!
							</p>
							<div className="row justify-content-center">
								<div className="col-md-6">
									<div className="features-preview">
										<h5 className="mb-3">What&apos;s Coming:</h5>
										<ul className="list-unstyled text-left">
											<li className="mb-2">
												<i className="bx bx-check text-success me-2"></i>
												Real-time delivery tracking
											</li>
											<li className="mb-2">
												<i className="bx bx-check text-success me-2"></i>
												Delivery partner management
											</li>
											<li className="mb-2">
												<i className="bx bx-check text-success me-2"></i>
												Route optimization
											</li>
											<li className="mb-2">
												<i className="bx bx-check text-success me-2"></i>
												Customer delivery notifications
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="mt-4">
								<small className="text-muted">Stay tuned for updates! 🚀</small>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default DeliveryOrders;
